import styled from 'styled-components';
import breakpoint from '../breakpoints';
const trackingToLetterSpacing = (spacing) => `${spacing/1000}em`;

export const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  margin-top: 45px;
  width: 90%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 70px 0;
  border-bottom: 1px solid #ccc;
  ${breakpoint('mobile', 'down')}{
    padding-top: 0;
    padding-bottom: 20px;
    margin: 30px auto 0;
  }
`
export const ExternalLink = styled.div`
  display: flex;
`
export const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  ${breakpoint('mobile', 'down')} {
    flex-direction: column;
  }
`

export const LinkIcon = styled.div`
  margin-top: 4px;
  padding-left: 5px;
  ${breakpoint('mobile', 'down')}{
    margin-top: 2px;
  }
`

export const MediaImg = styled.div`
flex: 0 0 calc(50% - 25px);
  img {
    width: 100%;
  }
`

export const MediaContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0 0 calc(50% - 25px);
  padding-right: ${({isHome}) => isHome ? '25px' : '0'};
  padding-left: ${({isHome}) => isHome ? '0' : '25px'};
`

export const Title = styled.h3`
  font-family: 'ToyotaType Bold';
  letter-spacing: ${trackingToLetterSpacing(0)};
  font-size: 26px;
  letter-spacing: 0.025em; 
  line-height: 36px; 
  margin-bottom: 10px;
  ${breakpoint('desktop', 'up')}{
    font-size: 26px;
  }
  ${breakpoint('mobile', 'down')}{
    padding-bottom: 5px;
    font-size: 18px; 
  }
`

export const Description = styled.p`
  font-family: 'ToyotaType Book';
  letter-spacing: ${trackingToLetterSpacing(50)};
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  ${breakpoint('mobile', 'down')}{
    text-align: left;
    padding-top: 5px;
  }
`

export const Link = styled.a`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  text-decoration: underline;
  color: #CC0000;
  &:hover {
    color: #990000;
  }
  ${breakpoint('mobile', 'down')}{
    align-self: flex-start;
    padding: 0;
    font-size: 14px;
  }
`

